<template>
  <el-form
    :model="reservation"
    label-position="top"
    ref="reservation"
    :rules="reservation_rules"
  >
    <div class="card-header bg-info">
      <div class="text-info m-0 d-flex align-items-start">
        <i class="fas fa-info-circle mr-2 mt-1"></i>
        <div v-html="texts['2_header']"></div>
      </div>
    </div>

    <div class="card-body border-bottom bg-light">
      <h4 class="m-0"><i class="far fa-calendar-check"></i> DÍAS Y HORARIOS</h4>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <el-form-item label="Días" prop="days">
            <div>
              <el-select
                v-model="reservation.days"
                placeholder="Selecciona días"
                class="w-100"
                multiple
              >
                <el-option
                  v-for="(item, index) in days"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <el-form-item label="Horarios" prop="timetables">
            <div>
              <el-select
                v-model="reservation.timetables"
                placeholder="Selecciona horario"
                class="w-100"
                multiple
              >
                <el-option
                  v-for="(item, index) in timetables"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <el-form-item label="Modalidad" prop="mode">
            <div>
              <el-select
                v-model="reservation.mode"
                placeholder="Selecciona Modalidad"
                class="w-100"
              >
                <el-option
                  v-for="(item, index) in modes"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>

        <div
          class="col-12 col-md-8 col-lg-12"
          v-if="user_id != null"
        >
          <el-form-item prop="politics">
            <el-checkbox v-model="reservation.politics">
              He leído y acepto la
              <a href="/legal" target="_blank" rel="noopener noreferrer"
                >Política de Privacidad</a
              >
            </el-checkbox>
          </el-form-item>
          <div>
            <el-checkbox v-model="reservation.publicity">
              Deseo recibir información puntual sobre otros cursos y talleres de
              London Calling. (El spam nos molesta tanto como a ti, así que no
              te daremos la lata, prometido)
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body border-top alert-warning py-3">
      <p class="m-0" v-html="texts['2_footer']"></p>
    </div>
    
    <div class="card-body bg-light border-top" style="display: flex; justify-content: space-between;">
      <el-button
        style="width: 100%; max-width: 200px"
        type="primary"
        plain
        @click="goOneStepBack"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        Atrás <i class="el-icon-arrow-left el-icon-left"></i>
      </el-button>
      <el-button
        v-if="user_id == null"
        style="width: 100%; max-width: 200px"
        type="primary"
        plain
        @click="changeForm('reservation')"
      >
        SIGUIENTE <i class="el-icon-arrow-right el-icon-right"></i>
      </el-button>
      <el-button
        v-if="user_id != null"
        style="width: 100%; max-width: 200px"
        type="primary"
        plain
        @click="sendBookingWithUser('reservation')"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        Finalizar <i class="el-icon-arrow-right el-icon-right"></i>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  props: ["user_id", "old_reservation", "texts", "type"],
  data() {
    return {
      fullscreenLoading: false,
      fac_data: false, // Control para la visualización de los datos de facturación
      reservation: {
        userId: null,
        date: new Date(),
        course: null,
        timetables: null,
        mode: null,
        days: null,
        userExist: false,
        politics: false,
        publicity: false,
      },
      reservation_id: null,
      degrees: [],
      timetables: {
        1: "08:00 - 10:00",
        2: "10:00 - 13:00",
        3: "15:00 - 18:00",
        4: "18:00 - 20:00",
        5: "Cualquier hora",
        6: "Cualquier hora por la mañana",
        7: "Cualquier hora por la tarde",
      },
      days: {
        1: "Lunes y miércoles",
        2: "Martes y jueves",
        3: "Viernes",
        4: "Lunes y miércoles o viernes",
        5: "Martes y jueves o viernes",
        6: "Cualquier día",
      },
      modes: {
        1: "Presencial",
        2: "Online",
      },
      reservation_rules: {
        mode: [
          {
            required: true,
            message: "Seleccione una modalidad",
            trigger: "change",
          },
        ],
        days: [
          {
            required: true,
            message: "Seleccione una franja de días",
            trigger: "change",
          },
        ],
        timetables: [
          {
            required: true,
            message: "Seleccione una franja horaria",
            trigger: "change",
          },
        ],
        politics: [
          {
            validator: (rule, value, callback) => {
              if (value === true) {
                callback();
              } else {
                callback(new Error("Debe aceptar las políticas de privacidad"));
                console.log("reservation_rules");
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.reservation = this.old_reservation    
    // Si es formulario de verano hay una opción más
    if (this.type == 2) {
      this.days[7] = "Todos los días, de lunes a viernes";
    }
  },
  methods: {
    async sendBookingWithUser(reservation) {
      this.$refs[reservation].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.$emit("sendReservationData", this.reservation, true);
        }
      });
    },
    changeForm(reservation) {
      this.$refs[reservation].validate((valid) => {
        if (valid) {
          this.$emit("sendReservationData", this.reservation);
          if (this.reservation.userExist) {
            this.fullscreenLoading = true;
            this.sendFormReservation();
          }
        }
      });
    },
    goOneStepBack () {
      this.$emit("goOneStepBack", true);
    }
  },
};
</script>

<style type="text/css" scoped>
.bg-info {
  background: #ecf5ff !important;
}
.text-info {
  color: #409eff !important;
}
</style>
